// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"id":"logo-stackblitz","fill":"props.strokeColor1","d":"M10.6119 14.857C10.7229 14.6414 10.5008 14.4258 10.2787 14.4258H3.83766C3.5045 14.4258 3.39345 14.1023 3.61555 13.8867L15.9424 0.0867952C16.1645 -0.128829 16.6087 0.0867951 16.4976 0.410231L13.4992 9.2508C13.3881 9.46643 13.4992 9.68203 13.7213 9.68203H20.1623C20.4955 9.68203 20.6066 10.0055 20.3845 10.2211L8.05764 23.9132C7.83555 24.1288 7.39133 23.9132 7.50238 23.5898L10.6119 14.857Z"}}]};

const LogoStackblitzIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'logo-stackblitz',
    ref,
    icon: element,
  },
));

LogoStackblitzIcon.displayName = 'LogoStackblitzIcon';

export default LogoStackblitzIcon;
